enum RouteRecomendation {
    Cheap = 'cheap',
    Direct = 'direct',
    Connection = 'connection',
}

export { RouteRecomendation };